window.marmeto = window.marmeto || {};
marmeto.Collection = (function() {
  var selectors = {
    priceFilterSelected: '[data-tag="Price"] .filter-selected',
    productCounter: '[data-product-count]',
    productContainer: '#js-product-loop',
    emptyProductContainer: '#js-empty-products',
    paginationContainer: '#js-pagination-holder',
    countElement: '#js-products-count',
    filterSidebar: '#sidebar-filter',
    filterItem: '.filter-item',
    clearFilterElement: '.clear-all',
    accordionHeading: '.js-accordion-heading',
    accordionContent: '.js-accordion-content',
    desktopSort: '#js-sort-desktop li',
    desktopSortSelectedText: '#js-sort-desktop [data-sort-value]',
    mobileSort: '#js-sort-mobile label input',
    mobileSortSelectedText: '#js-sort-mobile [data-sort-value]',
    mobileFilterOpener: '[data-action="open-filter"]',
    mobileFilterClose: '[data-action="close-filter"]',
    mobileSortClose: '[data-action="close-sort"]',
    mobileFilterCloseButton: '.mm-filter-close',
    mobileSortElem: '[data-action="open-sort"]',
    mobileSortByDrawer: '#js-sort-mobile',
    productSkeleton: 'skeleton-products'
  }
  function Collection(element) {
    this.container = document.querySelector('[data-section-type="' + element + '"]');
    
    if(!this.container) {
      return;
    }
    
    this.productsPerAjax = 100;
    this.allProducts = [];
    this.totalPage = '';
    this.params = {
      page: 1,
      q: undefined,
      filterOptions: undefined,
      sortBy: undefined
    };
    
    this.customFilters = this.initCustomFilters();
    this.options = JSON.parse(this.container.getAttribute('data-section-settings'));
        
    //FILL THE PRICE FILTER HIDDEN INPUT DATA-TAG
    if(history && history.state && history.state.filterOptions && history.state.filterOptions.price) {
      var priceRange = history.state.filterOptions.price[0];
      document.querySelector('.price-filter-item').dataset.tag = priceRange;
      
      document.querySelector('[name="PriceFilterMin"]').value = priceRange.split('-')[0];
      document.querySelector('[name="PriceFilterMax"]').value = priceRange.split('-')[1];
    }
       
    this.initQueryFromUrl();
    this.initCollection();
    this.attachEventListeners();
  }
  
  Collection.prototype.attachEventListeners = function() {
  	var _this = this;
        
    //FILTER SELECTION
    var filterItems = document.querySelectorAll(selectors.filterItem);
    for (var filterItem of filterItems) {
      filterItem.addEventListener('click', function() {
        this.classList.toggle('filter-selected');
        _this.handleFilterChange();
      })
    }
    
    //CLEAR FILTERS
    var clearElements = document.querySelectorAll(selectors.clearFilterElement);
    for (var clearElement of clearElements) {
      clearElement.addEventListener('click', function(event) {
        event.preventDefault();
        document.querySelector(selectors.filterSidebar).querySelectorAll(".filter-item").forEach(function(e){
          e.classList.remove('filter-selected');
        })  
        _this.handleFilterChange();
      })
    }
    
    //DESKTOP SORTING
    var sortElements = document.querySelectorAll(selectors.desktopSort);
    for (var sortElement of sortElements) {
      sortElement.addEventListener('click', function(event) {
        event.preventDefault();
		
        var sortValue = this.getAttribute('data-value');
        
        _this.params.sortBy = sortValue;
    	_this.getProducts(_this.params.page);       
        _this.handleFilterChange();
        document.querySelector(selectors.desktopSortSelectedText).innerHTML = this.textContent;
      })
    }
    
    //MOBILE SORTING
    var mobileSortElements = document.querySelectorAll(selectors.mobileSort);
    for (var mobileSortElement of mobileSortElements) {
      mobileSortElement.addEventListener('click', function(event) {
        // event.preventDefault();
        var mobileSortValue = this.getAttribute('data-value');
        _this.params.sortBy = mobileSortValue;
        _this.getProducts(_this.params.page);       
        _this.handleFilterChange();
        // document.querySelector(selectors.mobileSortByDrawer).classList.remove('is--opened');
      })
    }

   
    
    //ACCORDION
    var accordionHeadings = document.querySelectorAll(selectors.accordionHeading);
    for (var accordionHeading of accordionHeadings) {
      accordionHeading.addEventListener('click', function(event) {
        event.preventDefault();
        
        this.classList.toggle('is-closed');
		_this.helpers().slideToggle(this.nextElementSibling);
      })
    }
    
    //PAGINATION CLICK
    document.querySelector(selectors.paginationContainer).addEventListener('click', function(e) {
      e.preventDefault();
      var page = '';
      if(e.target.tagName === 'A') {
        page = e.target.getAttribute("data-page");
      } 
      else if(e.target.tagName === 'svg' || e.target.tagName === 'path') {
        page = e.target.closest('a').getAttribute("data-page");
      }
      _this.helpers().scrollToTop();
      if (page === '') page = '999';
      if (page !== '999') page = parseInt(page);
      if (page != _this.params.page) {
        _this.params.page = page;
        _this.pushState();
        _this.getProducts(page);
      }
    })
    
    //MOBILE FILTER DRAWER
    var filterOpenElement = document.querySelector(selectors.mobileFilterOpener);
    filterOpenElement?.addEventListener('click', function() {
      document.querySelector('.mmc-main__filter').classList.add('is--opened');
      document.querySelector('body').classList.add('filter-overflow-hidden');
      
      if (document.querySelector(selectors.mobileSortByDrawer).classList.contains('is--opened')) {
        document.querySelector(selectors.mobileSortByDrawer).classList.remove('is--opened')
      }
    })
    var filterCloseElements = document.querySelectorAll(selectors.mobileFilterClose);
    for (var filterCloseElement of filterCloseElements) {
      filterCloseElement.addEventListener('click', function() {
        document.querySelector('.mmc-main__filter').classList.remove('is--opened');
        document.querySelector('body').classList.remove('filter-overflow-hidden');
      })
    }
    
    //MOBILE SORT DRAWER
    var sortByOpenElem = document.querySelector(selectors.mobileSortElem);
    sortByOpenElem?.addEventListener('click', function() {
      document.querySelector(selectors.mobileSortByDrawer).classList.toggle('is--opened');
      document.body.classList.toggle('mobileSortBy');
    })

    var sortByCloseElements = document.querySelectorAll(selectors.mobileSortClose);
    for (var sortByCloseElem of sortByCloseElements) {
    sortByCloseElem?.addEventListener('click', function() {
        document.querySelector(selectors.mobileSortByDrawer).classList.toggle('is--opened');
        document.body.classList.toggle('mobileSortBy');
      })
    }
    
    // //PRICE FILTER CHANGE
    var minPriceInput = document.querySelector('[name="PriceFilterMin"]');
    var maxPriceInput = document.querySelector('[name="PriceFilterMax"]');
    
    if(minPriceInput != null){
      document.querySelector('[name="PriceFilterMin"]').addEventListener('change', function(event){      
        event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(maxPriceInput.value || event.target.max) - 1), event.target.min);
      
        var minPrice = event.target.value;
        var maxPrice = parseInt(maxPriceInput.value || event.target.max);
        var dataTag = minPrice + '-' + maxPrice;
        
        document.querySelector('.price-filter-item').dataset.tag = dataTag;
        document.querySelector('.price-filter-item').classList.add('filter-selected');
        _this.handleFilterChange();
      })
    }

    if(maxPriceInput != null){
      document.querySelector('[name="PriceFilterMax"]').addEventListener('change', function(event){
        event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(minPriceInput.value || event.target.min) + 1), event.target.max);
        
        var minPrice = parseInt(minPriceInput.value || event.target.min);
        var maxPrice = event.target.value;
        var dataTag = minPrice + '-' + maxPrice;
        
        document.querySelector('.price-filter-item').dataset.tag = dataTag;
        document.querySelector('.price-filter-item').classList.add('filter-selected');
        _this.handleFilterChange();
      })
    }
  }
  
  // Collection.prototype.initCollection = function() {
  // 	var _this = this,
  //       queries = [],
  //       sortUrl = '',
  //       view = '?view=json&page=',
  //       numRequests = Math.ceil(this.options.productCount / this.productsPerAjax);
  //   if(this.params.sortBy) {
  //     sortUrl = '&sort_by='+ this.params.sortBy;
  //   }
  //   for (var page=1; page <= numRequests; page++) {
  //     queries.push(fetch(location.pathname + view + page + sortUrl));
  //   }
    
  //   if(!queries.length) {
  //     console.error('Nothing to fetch!! Either you forgot to add .json template or the current page type doesn\'t have any products.')
  //     return; 
  //   }
  //   Promise.all(queries).then(function (responses) {
  //     Promise.all(responses.map(function (response) {
  //       return response.json();
  //     })).then(function (productsArray) { 
  //       for(var i=0; i<productsArray.length; i++) {
  //         var products = productsArray[i];
          
  //         for(var j=0; j<products.length; j++) {
  //           _this.allProducts.push(products[j])
  //         }
  //       }
  //       _this.getProducts(_this.params.page);
  //     });      
  //   });
  // }

  Collection.prototype.initCollection = async function() {
    var _this = this,
        queries = [],
        sortUrl = '',
        view = '?view=json&page=',
        numRequests = Math.ceil(this.options.productCount / this.productsPerAjax);
  
    if (this.params.sortBy) {
      sortUrl = '&sort_by=' + this.params.sortBy;
    }
  
    for (var page = 1; page <= numRequests; page++) {
      queries.push(fetch(location.pathname + view + page + sortUrl));
    }
  
    if (!queries.length) {
      console.error('Nothing to fetch!! Either you forgot to add .json template or the current page type doesn\'t have any products.');
      return;
    }
  
    try {
      const responses = await Promise.all(queries);
  
      const productsArray = await Promise.all(responses.map(async (response) => {
        return await response.json();
      }));
  
      for (var i = 0; i < productsArray.length; i++) {
        var products = productsArray[i];
  
        for (var j = 0; j < products.length; j++) {
          _this.allProducts.push(products[j]);
        }
      }
  
      _this.getProducts(_this.params.page);

      document.querySelectorAll('.shopify-section-group-footer-group .app-strip, .shopify-section-group-footer-group .custom-footer-section').forEach((e)=>{
          if (e.classList.contains('hidden')) {
              e.classList.remove('hidden');
          }
      })
      
    } catch (error) {
      // Handle errors here
      console.error('Error fetching data:', error);
    } finally {
      setTimeout(()=>{
        typeof(updateProductCards)==='function' && updateProductCards();
      },500);
    }
  }

  
  Collection.prototype.getProducts = function(pageNumber) {
    var _this = this,
    	priceRanges = [],
        getProducts = [],
    	filteredProducts = this.filterHelpers().filterProducts([...this.allProducts], this.params.filterOptions);
    
    /* EXCLUDE OUT OF STOCK PRODUCTS */
    if(this.options.excludeOosProducts) {
      getProducts = filteredProducts.filter(function(p) {
        return p.available;
      });
    } else {
      getProducts = filteredProducts;
    }
    
    this.sortProducts(getProducts);
    this.totalPage = Math.ceil(getProducts.length / this.options.productPerPage);
    
    /* SHOW OUT OF STOCK PRODUCTS ON LAST */
    if(this.options.showOosLast) {
      getProducts.sort(function(a,b) {
        return b.available - a.available
      })
    }
    
    if(document.querySelector(selectors.countElement)) {
      document.querySelector(selectors.countElement).innerHTML = 'Showing ' + getProducts.length +' products';
    }
       
    if(getProducts.length > 0 && pageNumber) {
      if (pageNumber !== '999' && pageNumber > this.totalPage) pageNumber = 1;
      
      var productGrid = "",
      	  endIndex = ((getProducts.length < (pageNumber * this.options.productPerPage)) || (pageNumber === '999') ) ? getProducts.length : pageNumber * this.options.productPerPage,
      	  startIndex = (pageNumber === '999' || (endIndex < this.options.productPerPage)) ? 0 : (pageNumber - 1) * this.options.productPerPage;
      for (var i=startIndex; i<endIndex; i++) {        
        productGrid += _this.htmlRenderer().renderProduct(i, getProducts[i]);        
      } 
      this.generatePagination(pageNumber);      
      document.querySelector(selectors.productContainer).classList.remove('is-hidden');
      document.querySelector(selectors.emptyProductContainer).classList.add('is-hidden');
      if(this.options.paginationType == 'infinite_scroll' && pageNumber !== 1) {
        document.querySelector(selectors.productContainer).innerHTML += productGrid;
      } else {
        document.querySelector(selectors.productContainer).innerHTML = productGrid;
      } 
    } else {
      document.querySelector(selectors.productContainer).innerHTML = '';
      document.querySelector(selectors.productContainer).classList.add('is-hidden');
      document.querySelector(selectors.paginationContainer).classList.add('is-hidden');
      document.querySelector(selectors.emptyProductContainer).classList.remove('is-hidden');  
    }
  }
  
  Collection.prototype.generatePagination = function(currentPage) {
    var _this = this;
    
    if(this.totalPage <= 1) {
      document.querySelector(selectors.paginationContainer).classList.add('is-hidden');
      return;
    }
    
    var paginationHtml = '';
    if (currentPage !== '999') {
      paginationHtml +=
        ((currentPage - 1 >= 1) ? '<a href="' + this.options.collectionUrl + '?page=' + (currentPage - 1) + '" class="pagination__item" rel="prev" title="Previous page" data-page="' + (currentPage - 1) + '"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3.00293 8.00004C3.00913 8.19072 3.08671 8.37972 3.23612 8.5254L9.64155 14.772C9.95238 15.076 10.4574 15.076 10.7691 14.772C11.0809 14.4689 11.0809 13.9764 10.7691 13.6724L4.95256 8.00001L10.7691 2.32764C11.0809 2.02362 11.0809 1.53114 10.7691 1.22802C10.4574 0.923993 9.95238 0.923993 9.64155 1.22802L3.23615 7.47462C3.08674 7.62033 3.00916 7.8093 3.00293 8.00001L3.00293 8.00004Z" fill="black"/></svg></a>' : '')
        + ((currentPage !== 1) ? '<a href="' + this.options.collectionUrl + '?page=1" class="pagination__item" title="Navigate to page 1" data-page="1">1</a>' : '')
        + ((currentPage >= 4) ? '…' : '')
        + ((currentPage - 2 > 1) ? '<a href="' + this.options.collectionUrl + '?page=' + (currentPage - 2) + '" class="pagination__item" title="Navigate to page ' + (currentPage - 2) + '" data-page="' + (currentPage - 2) + '">' + (currentPage - 2) + '</a>' : '')
        + ((currentPage - 1 > 1) ? '<a href="' + this.options.collectionUrl + '?page=' + (currentPage - 1) + '" class="pagination__item" title="Navigate to page ' + (currentPage - 1) + '" data-page="' + (currentPage - 1) + '">' + (currentPage - 1) + '</a>' : '')
        + '<span class="pagination__item pagination__item--current">' + currentPage + '</span>'
        + ((currentPage + 1 < this.totalPage) ? '<a href="' + this.options.collectionUrl + '?page=' + (currentPage + 1) + '" class="pagination__item" title="Navigate to page ' + (currentPage + 1) + '" data-page="' + (currentPage + 1) + '">' + (currentPage + 1) + '</a>' : '')
        + ((currentPage + 2 < this.totalPage) ? '<a href="' + this.options.collectionUrl + '?page=' + (currentPage + 2) + '" class="pagination__item" title="Navigate to page ' + (currentPage + 2) + '" data-page="' + (currentPage + 2) + '">' + (currentPage + 2) + '</a>' : '')
        + ((currentPage <= this.totalPage - 4) ? '…' : '')
        + ((currentPage !== this.totalPage) ? '<a href="' + this.options.collectionUrl + '?page=' + this.totalPage + '" class="pagination__item" title="Navigate to page ' + this.totalPage + '" data-page="' + this.totalPage + '">' + this.totalPage + '</a>' : '')
        + ((currentPage + 1 <= this.totalPage) ? '<a href="' + this.options.collectionUrl + '?page=' + (currentPage + 1) + '" class="pagination__item" rel="next" title="Next page" data-page="' + (currentPage + 1) + '"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M13 8C12.9938 7.80932 12.9162 7.62035 12.7668 7.47461L6.36138 1.22802C6.05055 0.923993 5.54555 0.923993 5.2338 1.22802C4.92207 1.53114 4.92207 2.02364 5.2338 2.32764L11.0504 8L5.2338 13.6724C4.92207 13.9764 4.92207 14.4689 5.2338 14.772C5.54555 15.076 6.05053 15.076 6.36138 14.772L12.7668 8.52539C12.9162 8.37968 12.9938 8.19068 13 8Z" fill="black"/></svg></a>' : '');
    }
    paginationHtml += '<a href="' + this.options.collectionUrl + '?page=' + (currentPage === '999' ? "1" : '999') + '" class="pagination__item" title="' + (currentPage === '999' ? 'View Less' : 'View All') + '" data-page="' + (currentPage === '999' ? '1' : '') + '">' + (currentPage === '999' ? 'View Less' : 'View All') + '</a>';
    paginationHtml += '<div class="infinite-scroll-element"></div>';

    document.querySelector(selectors.paginationContainer).innerHTML = paginationHtml;
    
    if(this.options.paginationType == 'infinite_scroll') {
      document.querySelector(selectors.paginationContainer).classList.add('is-hidden');
      const infiniteScroll = 
        document.querySelector(".infinite-scroll-element")
          let io = new IntersectionObserver((e) => {
              e[0].intersectionRatio <= 0 || _this.totalPage <= currentPage || _this.getProducts(currentPage + 1);
          });
        io.observe(infiniteScroll);
      
    } else {
      document.querySelector(selectors.paginationContainer).classList.remove('is-hidden');
    }

    setTimeout(()=>{
      typeof(updateProductCards)==='function' && updateProductCards();
    },500);

  }
  Collection.prototype.initQueryFromUrl = function() {
    var queryString = this.helpers().generateQuery();
    if (queryString.q) {
      this.params.q = queryString.q;
    }
    if (queryString.sort_by) {	
      this.params.sortBy = queryString.sort_by;
    }
    if (queryString.page) {
      this.params.page = parseInt(queryString.page);
    }
    if (this.params.q) {
      this.params.q = decodeURI(this.params.q);      	
      this.filterHelpers().searchToFilter(this.params.q.split(','));
      this.handleFilterChange();
    }
    
    if(this.params.filterOptions) {
      this.filterHelpers().setFilterOptions(this.params);
    }
  }
  
  Collection.prototype.sortProducts = function(sortedProducts) {
    var e = 0;
    
    if (this.params.sortBy == 'title-descending')
      e = function (b,a) { return a.title.localeCompare(b.title)}
    else if (this.params.sortBy == 'title-ascending')
      e = function (a,b) { return a.title.localeCompare(b.title)}
    else if (this.params.sortBy == 'price-ascending')
      e = function (a,b) { return a.price_num - b.price_num}
    else if (this.params.sortBy == 'price-descending')
      e = function (b,a) { return a.price_num - b.price_num}
    else if (this.params.sortBy == 'created-descending')
      e = function (a,b) { return (a.published_at > b.published_at  ? -1 : (a.published_at == b.published_at  ? a.title.localeCompare(b.title) : 1)); }
    else if (this.params.sortBy == 'created-ascending')
      e = function (a,b) { return (a.published_at > b.published_at  ? 1 : (a.published_at == b.published_at  ? a.title.localeCompare(b.title) : -1)); }
    
    if (e) {
      return sortedProducts.sort(e);
    }
    
    return sortedProducts;
  }
  
  Collection.prototype.pushState = function() {
    var a = {},	
        p = !1,	
        _this = this,
        path = location.pathname,
        searchParams = new URLSearchParams();
        
    1 != _this.params.page && ((a.page = _this.params.page), (p = 1)), 
    _this.params.sortBy && _this.params.q && ((a.sortBy = _this.params.sortBy), (a.q = _this.params.q), (p = 1)), 
    _this.params.q && ((a.q = _this.params.q), (p = 1)), _this.params.sortBy && ((a.sortBy = _this.params.sortBy), (p = 1));	
  
    if(a.q){	
      a.q = decodeURI(a.q);	
    }	
      
    Object.keys(a).forEach(function(key){searchParams.append(key, a[key])})
    p && (path = "?" + searchParams.toString()), history.pushState({
      filterOptions: _this.params.filterOptions
    }, " ", path)
  }
  
  Collection.prototype.handleFilterChange = function() {
  	var _this = this;
    
    _this.params.filterOptions = _this.filterHelpers().fillFilter();
    if (_this.params.page !== '999') _this.params.page = 1;
    _this.getProducts(_this.params.page);
    
    var query = Object.keys(_this.params.filterOptions).map(function(o) {
      return _this.params.filterOptions[o].map(function(o) {
        return encodeURIComponent(o)
      }).join(',')
    }).join(',');
    
    if (query) {
      query = location.pathname + '?q=' + query;
      
      if(_this.params.sortBy){ 
        query += '&sort_by='+ _this.params.sortBy 
      }
    } else {
      query = location.pathname;
      if(_this.params.sortBy){ 
        query += '?sort_by='+ _this.params.sortBy 
      }
    }
    
    history.replaceState(_this.params, 'Filtered', query);

    setTimeout(()=>{
      typeof(updateProductCards)==='function' && updateProductCards();
    },500);
  }
  /*
   * HELPER FUNCTIONS FOR FILTERING
   */
  Collection.prototype.filterHelpers = function() { 
  	var _this = this,
        sidebarFilter = document.querySelector(selectors.filterSidebar);
    
    return {
      filterProducts: function(data, filters) {
        var output = [];
        if(filters&&Object.keys(filters).length)for(var i=0;i<data.length;i++)_this.helpers().productTagFilter(filters,data[i])&&output.push(data[i]);else output=data;
        return output;
      },
      fillFilter: function() {
        var andtags = {};
        document.querySelectorAll(".and", sidebarFilter).forEach(function(a) {
          var t = [];
          a.querySelectorAll(".or.filter-selected").forEach(function(a) {
            t.push(_this.helpers().getTagName(a))
          }), t.length && (andtags[a.getAttribute("data-tag")] = t)
        });
        return andtags;
      },
      searchToFilter: function(arr) {
        document.querySelectorAll(".and", sidebarFilter).forEach(function(a) {
          a.querySelectorAll(".or").forEach(function(a) {
            -1 !== arr.indexOf(_this.helpers().getTagName(a)) && a.classList.add("filter-selected")
          })
        });
      },
      setFilterOptions: function(filters) {
        document.querySelectorAll(".and", sidebarFilter).forEach(function(a) {
          var e = a.getAttribute("data-tag");
          var i = filters[e];
          
          i && i.length && a.querySelectorAll(".or").forEach(function(a) {
            i.indexOf(_this.helpers().handleize(a.getAttribute("data-tag")) || _this.helpers().handleize(a.textContent).trim()) >= 0 && a.classList.add("filter-selected")
          })
        });
      }
    }
  }
  
  /*
   * TINY HELPERS FUNCTIONS
   */
  Collection.prototype.helpers = function() { 
    var _this = this;
    
    return {
      handleize: function(string) {
        return string.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
      },
      scrollToTop: function() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
      generateQuery: function() {
        var url = window.location.href;
        var urlParams= url.split('?'),
            queryArray = [];
    
        if (urlParams.length != 2) {
          return queryArray;
        }
    
        var splitUrl = urlParams[1].split('&');
        for (var i = 0; i < splitUrl.length; i++) {
          var splitEqual  = splitUrl[i].split('=');
          queryArray[splitEqual[0]] = splitEqual[1];
        }
        return queryArray;
      },
      getTagName: function(element) {
        return _this.helpers().handleize(element.getAttribute('data-tag')) || _this.helpers().handleize(element.textContent).trim();       
      },
      basicSearch: function(ortags, classes) {
        var or = false;
        
        classes = classes.map(function(c) {
          return _this.helpers().handleize(c)
        });
        if("object" == typeof ortags) {
          Object.keys(ortags).forEach(function(item){
            if(classes.indexOf(ortags[item]) > -1) return or=!0, !1
          });
        }
        else {
          [ortags].forEach(function(items) {
            Object.keys(items).forEach(function(item) {
              if(classes.indexOf(items[item]) > -1) return or=!0, !1
            });
          })
        }
        return or;
      },
      basicTagSearch: function(ortags, object) {
        return object.tags ? _this.helpers().basicSearch(ortags, object.tags) : false;
      },
      productTagFilter: function(filters, object) {
        var and = true;
        
        Object.keys(filters).forEach(function(ortags) {
          if(and && filters[ortags] && filters[ortags].length) {
            and = and && (_this.customFilters[ortags] ? _this.customFilters[ortags](filters[ortags],object) : _this.helpers().basicTagSearch(filters[ortags],object))
          }
          return and;
        });
        return and;
      },
      compareRanges: function(r,n) {
        for(var e=0;e<n.length;e++)if(r>=n[e][0]&&r<=n[e][1])return!0;return!1
      },
      formatMoney: function(cents, format) {
      	var moneyFormat = '$';
        
        if (typeof cents === 'string') {
          cents = cents.replace('.', '');
        }
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = format || moneyFormat;
        function formatWithDelimiters(number, precision, thousands, decimal) {
          thousands = thousands || ',';
          decimal = decimal || '.';
          if (isNaN(number) || number === null) {
            return 0;
          }
          number = (number / 100.0).toFixed(precision);
          var parts = number.split('.');
          var dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            '$1' + thousands
          );
          var centsAmount = parts[1] ? decimal + parts[1] : '';
          return dollarsAmount + centsAmount;
        }
        switch (formatString.match(placeholderRegex)[1]) {
          case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
          case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 0, ' ');
            break;
          case 'amount_with_apostrophe_separator':
            value = formatWithDelimiters(cents, 2, "'");
            break;
        }
        return formatString.replace(placeholderRegex, value);
      },
      slideToggle: function(target, duration=300) {
        //TODO:: FIND A BETTER SOLUTION FOR THIS          
      	function slideUp(e,t=500){e.style.transitionProperty="height, margin, padding",e.style.transitionDuration=t+"ms",e.style.boxSizing="border-box",e.style.height=e.offsetHeight+"px",e.offsetHeight,e.style.overflow="hidden",e.style.height=0,e.style.paddingTop=0,e.style.paddingBottom=0,e.style.marginTop=0,e.style.marginBottom=0,window.setTimeout(function(){e.style.display="none",e.style.removeProperty("height"),e.style.removeProperty("padding-top"),e.style.removeProperty("padding-bottom"),e.style.removeProperty("margin-top"),e.style.removeProperty("margin-bottom"),e.style.removeProperty("overflow"),e.style.removeProperty("transition-duration"),e.style.removeProperty("transition-property")},t)}
      	function slideDown(e,t=500){e.style.removeProperty("display");let o=window.getComputedStyle(e).display;"none"===o&&(o="block"),e.style.display=o;let r=e.offsetHeight;e.style.overflow="hidden",e.style.height=0,e.style.paddingTop=0,e.style.paddingBottom=0,e.style.marginTop=0,e.style.marginBottom=0,e.offsetHeight,e.style.boxSizing="border-box",e.style.transitionProperty="height, margin, padding",e.style.transitionDuration=t+"ms",e.style.height=r+"px",e.style.removeProperty("padding-top"),e.style.removeProperty("padding-bottom"),e.style.removeProperty("margin-top"),e.style.removeProperty("margin-bottom"),window.setTimeout(function(){e.style.removeProperty("height"),e.style.removeProperty("overflow"),e.style.removeProperty("transition-duration"),e.style.removeProperty("transition-property")},t)}
      
        if (window.getComputedStyle(target).display === 'none') {
          return slideDown(target, duration);
        } else {
          return slideUp(target, duration);
        }
      }
    }
  }
  
  /*
   * DEFAULT CUSTOM FILTERS
   */
  Collection.prototype.initCustomFilters = function() {
    var _this = this;
    
    return {
      availability: function(ortags, product) {
        var or = false;
        
        ortags.filter(function(tag) {
          if(tag == 'in-stock' && product.available) or = true;
          if(tag == 'out-of-stock' && !product.available) or = true;
        })
        return or;
      },
      brand: function(ortags, product) {
        var or = false;
         
        ortags.filter(function(tag) {
          if(product.vendor && _this.helpers().handleize(tag) == _this.helpers().handleize(product.vendor)) or = true;
        })        
        return or;
      },
      size: function(ortags, product) {
        var or = false;
        ortags.filter(function(tag) {
          product.variants.forEach(function(variant) {
            if(	 variant.option1 && _this.helpers().handleize(tag) == _this.helpers().handleize(variant.option1)
              || variant.option2 && _this.helpers().handleize(tag) == _this.helpers().handleize(variant.option2)
              || variant.option3 && _this.helpers().handleize(tag) == _this.helpers().handleize(variant.option3)
              ) {
              or = true;
            }
          })
        })
        return or;
      },      
      color: function(ortags, product) {
        var or = false;
        ortags.filter(function(tag) {
          product.variants.forEach(function(variant) {
            if(	 variant.option1 && _this.helpers().handleize(tag) == _this.helpers().handleize(variant.option1)
              || variant.option2 && _this.helpers().handleize(tag) == _this.helpers().handleize(variant.option2)
              || variant.option3 && _this.helpers().handleize(tag) == _this.helpers().handleize(variant.option3)
              ) {
              or = true;
            }
          })
        })
        return or;
      },      
      price: function(ortags, product) {
        var or = false,
            prices = [];
        ortags.filter(function(tag) {
          prices.push(tag.split('-'));  
          
          if(_this.helpers().compareRanges(product.price / 100, prices)) or = true;
        })
        return or;
      },
      producttype: function(ortags, product) {
        var or = false;
        ortags.filter(function(tag) {
          if(product.type && _this.helpers().handleize(tag) == _this.helpers().handleize(product.type)) or = true;
        })
        return or;
      },
      Discount: function discount(t, o) {
        let n = false;
        t = (typeof t === 'object') ? t : [t];
        t.forEach(function(e) {
          let r = parseInt(e);
          if (Math.round(100 - o.price_num / o.compare_at_price_num * 100) >= r) {
            n = true;
            return false;
          }
        });
        return n;
      },
      Reviews: function checkOrTags(ortags, product) {
        let or = false;
        const tags = Array.isArray(ortags) ? ortags : [ortags];
        tags.forEach(function (tag) {
          let desiredCount = parseInt(tag.split('-')[0]);
          if(product.review_html) {
            const regex = /data-average-rating='([0-9.]*)'/;
            const match = product.review_html.match(regex);
            const reviewAverage = match ? parseFloat(match[1]) : 0;  
            if(reviewAverage > desiredCount) {
              or = true;
              return false;
            }	
          }
        });
        return or;
      }
    }
  }
  
  /*
   * CREATE FILTER & PRODUCT CARDS HTML
   */
  Collection.prototype.htmlRenderer = function() {
  	var _this = this;
    
    return {
      renderProduct: function (index, product) {
      	var productHtml = '';
        var image_space = 100;
        var product_tags = product.tags;
        var sale_percent = ((product.compare_at_price_num - product.price_num) / product.compare_at_price_num) * 100;
        var sale_percent = sale_percent.toFixed(0);
        
        
        if(product.featured_image) {
          var splitImage = product.featured_image.split(".");          
          splitImage[splitImage.length-2] = splitImage[splitImage.length-2] + "_360x";
          
          var product_image = splitImage.join('.');
          image_space = 100 / product.media[0].aspect_ratio;
        }
        productHtml += '<div class="grid__item" data-index='+ index +'">';
        productHtml += '<div class="mm-product-card product-item product-card">';
        
        productHtml += '<a href='+ product.url +' class="mmc-card-image" style="padding-bottom: '+ image_space +'%;">';
        productHtml += '<img src='+ product_image +'" alt='+ product.title +'" />';

        // if (product_tags.includes('pre_order-product')) {
        //   productHtml += '<div class="preorder-tabs"><span>PRE-ORDER</span></div>';
        // }
        
        productHtml += '</a>';
      
        productHtml += '<div class="mmc-card-info">'; 

        if (product.discountPercentage > 0) {
        
          productHtml += '<div class="countdown-container-pdp onsale trending dicountPercentage">';
          productHtml += '<svg height="14px" id="Layer_1" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" width="14px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">';
          productHtml += '<path d="M302.7,64L143,288h95.8l-29.5,160L369,224h-95.8L302.7,64L302.7,64z" fill="white"/>';
          productHtml += '</svg>';
          productHtml += '<count-down-pdp';
          productHtml += ' data-endYear="2022"';
          productHtml += ' data-endMonth="10"';
          productHtml += ' data-endDay="27"';
          productHtml += ' data-endHour="16"';
          productHtml += ' data-endMinute="0"';
          productHtml += ' data-countdownFormat="<div>{hours}h {minutes}m {seconds}s</div>"';
          productHtml += ' class="text-white count_down--pdp sale">';
          productHtml += '</count-down-pdp>';
          productHtml += '</div>';
        }
        
        productHtml += '<div class="product-reviews-badge">';
        productHtml += ' ';
        if (product.review_count) {
          let productRatings = Math.round(product.review_ratings * 10) / 10
          productHtml += '<div class="product-reviews-ratings" data-score="'+ productRatings +'">';
          productHtml += ''+ productRatings +'<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" style="fill: rgb(230, 123, 120);transform: ;msFilter:;vertical-align: -1.5;"><path d="M21.947 9.179a1.001 1.001 0 0 0-.868-.676l-5.701-.453-2.467-5.461a.998.998 0 0 0-1.822-.001L8.622 8.05l-5.701.453a1 1 0 0 0-.619 1.713l4.213 4.107-1.49 6.452a1 1 0 0 0 1.53 1.057L12 18.202l5.445 3.63a1.001 1.001 0 0 0 1.517-1.106l-1.829-6.4 4.536-4.082c.297-.268.406-.686.278-1.065z"></path></svg>'
          productHtml += '</div>';
          productHtml += '('+ product.review_count+' ';
          if (product.review_count > 1)
            productHtml += 'reviews)';
          else
            productHtml += 'review)';
        }
        productHtml += '</div>';
        
        productHtml += '<a href='+ product.url +' class="mm-product-title">'+ product.title +'</a>';
        
        productHtml += '<div class="mmc-card-price">';        
        
        if(product.compare_at_price_num > product.price_num) {
          productHtml += '<span class="mm-sale-price">'+ product.price  +'</span>';
          productHtml += '<span class="mm-original-price">'+ product.compare_at_price +'</span>';
        } else {
          productHtml += '<span class="mm-product-price">'+ product.price +'</span>';
        }
        productHtml += `</div><div class="pop-club-listing" price="${product.price.replace('Rs.','').replace(' ','').replace(',','')}" prodId="${product.id}"></div>`;

        // if (product.toggle){
        // productHtml += '<span class="mm-product-offer-price"> Offer Price: '+ product.offerprice +'</span>';
        // }
        productHtml += '<div class="collection-tags-container">';
        productHtml += '<div class="trending-container">'

        if (product_tags.includes('preorder')){
          productHtml += '<div class="trending_col"><span class="sale-col">Pre-order</span></div>';
        }else {

          if (product_tags.includes('badge-india-first')) {
            productHtml += '<div class="trending_col"><span class="sale-col">INDIA\'S FIRST</span></div>';
          }

          if (!product.available){
            productHtml += '<div class="trending_col out-of-stock-badge"><span class="sale-col">Out of stock</span></div>';
          }
          
          if (product_tags.includes('best-seller')) {
            productHtml += '<div class="trending_col"><span class="sale-col">BEST SELLER</span></div>';
          }

          if (product_tags.includes('Monsoon-Ready')) {
            productHtml += '<div class="trending_col"><span class="sale-col">Monsoon Ready</span></div>';
          }
          
          if (product_tags.includes('badge-new')) {
            productHtml += '<div class="trending_col"><span class="sale-col">NEW</span></div>';
          }

          if (product_tags.includes('badge-skintype')) {
            productHtml += '<div class="trending_col"><span class="sale-col">Skin Type</span></div>';
          }

          if (product_tags.includes('product_ninetynine')) {
            productHtml += '<div class="trending_col"><span class="sale-col">99</span></div>';
          }
          
          if (product_tags.includes('Trending')) {
            productHtml += '<div class="trending_col"><span>TRENDING</span></div>';
          }

          if (product_tags.includes('badge-back-in-stock')) {
            productHtml += '<div class="trending_col"><span>BACK IN STOCK</span></div>';
          }
        }
        productHtml += '</div>'
        productHtml += '<div class="mm-badges_col">';
        if (product_tags.includes('badge-b3g3')) {
            productHtml += '<div class="sale-col onsale-color"><span>BUY 3 GET 3</span></div>';
          }else if (product_tags.includes('badge-buyonegetone')) {
            productHtml += '<div class="sale-col onsale-color"><span>BUY 1 GET 1</span></div>';
          }else if (product_tags.includes('30-percent-off')) {
            productHtml += '<div class="sale-col onsale-color"><span>FLAT 30% OFF</span></div>';
          }else if (product_tags.includes('badge-buyeightnine')) {
            productHtml += '<div class="sale-col onsale-color"><span>ANY 3 @899</span></div>';
          }else if (product_tags.includes('badge-B3899')) {
            productHtml += '<div class="sale-col onsale-color"><span>ANY 3 @899</span></div>';
          }else if (product_tags.includes('badge-B3999')) {
            productHtml += '<div class="sale-col onsale-color"><span>BUY 3 @999</span></div>';
          }else if (product_tags.includes('badge-buyninenine')) {
            productHtml += '<div class="sale-col onsale-color"><span>BUY 3 @999</span></div>';
          }else if (product_tags.includes('badge-buysixnine')) {
            productHtml += '<div class="sale-col onsale-color"><span>ANY 2 @699</span></div>';
          }else if (product_tags.includes('badge-B2649')) {
            productHtml += '<div class="sale-col onsale-color"><span>ANY 2 @649</span></div>';
          }else if (product_tags.includes('badge-b2g3')) {
            productHtml += '<div class="sale-col onsale-color"><span>BUY 2 GET 3</span></div>';
           }else if (product_tags.includes('badge-b2g1')) {
            productHtml += '<div class="sale-col onsale-color"><span>BUY 2 GET 1</span></div>';
          }else if (product_tags.includes('badge-bxgx')) {
            productHtml += '<div class="sale-col onsale-color"><span>BUY 2 GET 2</span></div>';
          }else if (product_tags.includes('badge-bygy')) {
            productHtml += '<div class="sale-col onsale-color"><span>B3P2</span></div>';
          }else if (product_tags.includes('badge__Men')) {
            productHtml += '<div class="sale-col onsale-color"><span>Men</span></div>';
          }else if (product_tags.includes('badge__Women')) {
            productHtml += '<div class="sale-col onsale-color"><span>Women</span></div>';
          }else if (product_tags.includes('badge-Unisex')) {
            productHtml += '<div class="sale-col onsale-color"><span>Unisex</span></div>';
          }else if (product_tags.includes('badge-buyabc')) {
            productHtml += '<div class="sale-col onsale-color"><span>ANY 3 @899<br>ANY 2 @899</span></div>';
          }else if (product_tags.includes('badge-SERUM20')) {
            productHtml += '<div class="sale-col onsale-color"><span>SERUM20</span></div>'; 
          }else if (product_tags.includes('badge-Oilyskin')) {
            productHtml += '<div class="sale-col onsale-color"><span>Oily Skin</span></div>'; 
          }else if (product_tags.includes('badge-Dehydratedskin')) {
            productHtml += '<div class="sale-col onsale-color"><span>Dehydrated Skin</span></div>'; 
          }else if (product_tags.includes('badge-Antiageing')) {
            productHtml += '<div class="sale-col onsale-color"><span>Anti-Ageing</span></div>'; 
          }else if (product_tags.includes('badge-Dryskin')) {
            productHtml += '<div class="sale-col onsale-color"><span>Dry Skin</span></div>';
          }else if (product_tags.includes('badge-Acneproneskin')) {
            productHtml += '<div class="sale-col onsale-color"><span>Acne Prone Skin</span></div>';
          }else if (product_tags.includes('special-badge-face')) {
            productHtml += '<div class="sale-col onsale-color"><span>Face</span></div>';
          } else if (product_tags.includes('special-badge-body')) {
            productHtml += '<div class="sale-col onsale-color"><span>Body</span></div>';
          }if(product.compare_at_price_num > product.price_num && sale_percent > 3) {
            productHtml += '<div class="onsale-col"><span class="sale-col">-'+ sale_percent +'%</span></div>';
        }
        
        productHtml += '</div>';
        productHtml += '</div>';

        // Product subtitle
        productHtml += '<div class="mCaffeine__meta-tags">'+ product.metafields[0].subtitle +'</div>';  

        if (product_tags.includes('pre_order-product')) {
          productHtml += '<a href='+ product.url +'><div class="pre-order-btn"><span>PRE-ORDER</span></div></a>';
        }
        else if (!product.available){
          productHtml += `<render-notifyme-form data-product-title='${product.title}' data-product-id='${product.id}' data-variant-id='${product.variants[0].id}' data-sku-id='${product.variants[0].sku}' class="product-card-notify-me">Notify me</render-notifyme-form>`
        } 
        else {
          // Add to Cart button
          const productLoop = document.querySelector("#js-product-loop");
          // productHtml += `<product-form data-section-title="${productLoop.dataset.sectionTitle}" data-collection-name="${productLoop.dataset.collectionName}">`;
          // productHtml += '<form method="post" id="product_form_id" class: "form" novalidate: "novalidate" data-type: "add-to-cart-form">';
  
          // productHtml +='<input type="hidden" name="id" value="'+ product.variants[0].id +'" disabled >';
          // productHtml += '<button id="quick-add-'+ product.id +'-submit" type="submit" name="add" class="quick-add__submit button button--full-width button--secondary" aria-haspopup="dialog" aria-live="polite" data-sold-out-message="true" data-variant="'+ product.variants[0].id +'" data-category="N/A" data-category-id="N/A" data-name="'+ product.title +'" data-id="'+ product.id +'" data-product-url="/'+ product.handle +'" data-price="'+ product.price_num +'" data-brand="'+ product.vendor +'" data-type="'+ Object.values(product.tags).find( tag => tag.includes('category__') )?.split('__')[1] +'" data-subcategory="NA" data-subcategory-id="NA" data-retail-price="'+ product.compare_at_price +'" data-discount="'+ (product.compare_at_price - product.price) / 100 +'" data-variant-title="'+ product.variants[0].title +'" data-currency="" data-size="NA" data-image="'+ product.featured_image +'" data-index="'+ index +'">'      
          // if (product.available) {
          //   let atcText = product_tags.includes('pre_order-product-new') ? 'PRE-ORDER' : 'ADD TO CART';
          //   productHtml += `<span> <svg xmlns="http://www.w3.org/2000/svg" width="21.778" height="21.233" viewBox="0 0 21.778 21.233"><defs><style>.atc-a{fill:#040506;}.atc-b{fill:#fff;}</style></defs><g transform="translate(-20.369)"><g transform="translate(20.369 0.196)"><path class="atc-a" d="M463.279,341.606h9.592a2.982,2.982,0,0,1,1.873.654,2.672,2.672,0,0,1,.968,1.646l1.954,12.063a2.6,2.6,0,0,1-.661,2.173,2.948,2.948,0,0,1-2.18.943H461a2.941,2.941,0,0,1-2.2-.969,2.59,2.59,0,0,1-.627-2.213l2.277-12.063A2.829,2.829,0,0,1,463.279,341.606Zm11.546,17.066a2.5,2.5,0,0,0,1.848-.8,2.2,2.2,0,0,0,.56-1.842l-1.954-12.063a2.265,2.265,0,0,0-.821-1.395,2.528,2.528,0,0,0-1.587-.554h-9.592a2.4,2.4,0,0,0-2.4,1.893L458.6,355.975a2.2,2.2,0,0,0,.531,1.876,2.493,2.493,0,0,0,1.867.821Zm-11.546-16.613h9.592a2.483,2.483,0,0,1,1.559.544,2.225,2.225,0,0,1,.806,1.37l1.954,12.063a2.162,2.162,0,0,1-.55,1.809,2.454,2.454,0,0,1-1.815.785H461a2.449,2.449,0,0,1-1.834-.806,2.156,2.156,0,0,1-.522-1.842l2.277-12.063A2.355,2.355,0,0,1,463.279,342.059Zm11.546,16.159a2.005,2.005,0,0,0,1.483-.642,1.766,1.766,0,0,0,.45-1.478L474.8,344.036a1.817,1.817,0,0,0-.659-1.119,2.029,2.029,0,0,0-1.274-.445h-9.592a1.924,1.924,0,0,0-1.925,1.519l-2.277,12.063a1.762,1.762,0,0,0,.426,1.505,2,2,0,0,0,1.5.659Z" transform="translate(-458.128 -338.047)"></path><path class="atc-a" d="M487.748,333.729a.447.447,0,0,1-.46-.433,9.676,9.676,0,0,0-.346-2.6,7.408,7.408,0,0,0-.93-2.094,4.589,4.589,0,0,0-1.327-1.362,2.709,2.709,0,0,0-3.055,0A4.586,4.586,0,0,0,480.3,328.6a7.4,7.4,0,0,0-.929,2.094,9.677,9.677,0,0,0-.346,2.6.46.46,0,0,1-.919,0,9.439,9.439,0,0,1,1.413-5.15,5.466,5.466,0,0,1,1.59-1.621,3.673,3.673,0,0,1,4.09,0,5.468,5.468,0,0,1,1.59,1.621,9.439,9.439,0,0,1,1.414,5.15A.447.447,0,0,1,487.748,333.729Zm-4.589-7.372a3.252,3.252,0,0,1,1.774.543,5.007,5.007,0,0,1,1.453,1.485,7.8,7.8,0,0,1,.981,2.206,10.063,10.063,0,0,1,.36,2.7.022.022,0,0,0,.043,0,9.041,9.041,0,0,0-1.348-4.932,5.049,5.049,0,0,0-1.465-1.5,3.213,3.213,0,0,0-3.6,0,5.048,5.048,0,0,0-1.465,1.5,9.042,9.042,0,0,0-1.347,4.932.022.022,0,0,0,.043,0,10.068,10.068,0,0,1,.36-2.7,7.807,7.807,0,0,1,.981-2.206,5.008,5.008,0,0,1,1.453-1.485A3.252,3.252,0,0,1,483.159,326.357Z" transform="translate(-473.303 -325.904)"></path></g><circle cx="6" cy="6" r="6" transform="translate(30.147)"></circle><path class="atc-b" d="M.228-5.889v2.8h-2.77v.912H.228v2.8H1.19v-2.8H3.944v-.912H1.19v-2.8Z" transform="translate(35.443 8.684)"></path></g></svg> ${atcText} </span>`;
          // } else {
          //   productHtml += '<span class="sold-out-inactive">Sold out</span>';
          // }
          
          productHtml += `<product-form data-section-title="${productLoop.dataset.sectionTitle}" data-collection-name="${productLoop.dataset.collectionName}" data-product-title="${product.title}" data-productId="${product.id}" data-variantId="${product.variants[0].id}" data-skuId="${product.variants[0].sku}" data-interaction-date = "20-04-2026" data-isPreOrder="${product.tags.includes('preorder')}" data-product-link="${product.url}">`;
          productHtml += '<form method="post" id="product_form_id" class: "form" novalidate: "novalidate" data-type: "add-to-cart-form">';
  
          productHtml +='<input type="hidden" name="id" value="'+ product.variants[0].id +'" disabled >';
          productHtml += '<button id="quick-add-'+ product.id +'-submit" type="submit" name="add" class="quick-add__submit button button--full-width button--secondary" aria-haspopup="dialog" aria-live="polite" data-sold-out-message="true" data-variant="'+ product.variants[0].id +'" data-category="N/A" data-category-id="N/A" data-name="'+ product.title +'" data-id="'+ product.id +'" data-product-url="/'+ product.handle +'" data-price="'+ product.price_num +'" data-brand="'+ product.vendor +'" data-type="'+ Object.values(product.tags).find( tag => tag.includes('category__') )?.split('__')[1] +'" data-subcategory="NA" data-subcategory-id="NA" data-retail-price="'+ product.compare_at_price +'" data-discount="'+ (product.compare_at_price - product.price) / 100 +'" data-variant-title="'+ product.variants[0].title +'" data-currency="" data-size="NA" data-image="'+ product.featured_image +'" data-index="'+ index +'">'      
          if (product.available) {
            let atcText = product_tags.includes('preorder') ? 'PRE-ORDER' : 'ADD TO CART';
            productHtml += `<span> <svg xmlns="http://www.w3.org/2000/svg" width="21.778" height="21.233" viewBox="0 0 21.778 21.233"><defs><style>.atc-a{fill:#040506;}.atc-b{fill:#fff;}</style></defs><g transform="translate(-20.369)"><g transform="translate(20.369 0.196)"><path class="atc-a" d="M463.279,341.606h9.592a2.982,2.982,0,0,1,1.873.654,2.672,2.672,0,0,1,.968,1.646l1.954,12.063a2.6,2.6,0,0,1-.661,2.173,2.948,2.948,0,0,1-2.18.943H461a2.941,2.941,0,0,1-2.2-.969,2.59,2.59,0,0,1-.627-2.213l2.277-12.063A2.829,2.829,0,0,1,463.279,341.606Zm11.546,17.066a2.5,2.5,0,0,0,1.848-.8,2.2,2.2,0,0,0,.56-1.842l-1.954-12.063a2.265,2.265,0,0,0-.821-1.395,2.528,2.528,0,0,0-1.587-.554h-9.592a2.4,2.4,0,0,0-2.4,1.893L458.6,355.975a2.2,2.2,0,0,0,.531,1.876,2.493,2.493,0,0,0,1.867.821Zm-11.546-16.613h9.592a2.483,2.483,0,0,1,1.559.544,2.225,2.225,0,0,1,.806,1.37l1.954,12.063a2.162,2.162,0,0,1-.55,1.809,2.454,2.454,0,0,1-1.815.785H461a2.449,2.449,0,0,1-1.834-.806,2.156,2.156,0,0,1-.522-1.842l2.277-12.063A2.355,2.355,0,0,1,463.279,342.059Zm11.546,16.159a2.005,2.005,0,0,0,1.483-.642,1.766,1.766,0,0,0,.45-1.478L474.8,344.036a1.817,1.817,0,0,0-.659-1.119,2.029,2.029,0,0,0-1.274-.445h-9.592a1.924,1.924,0,0,0-1.925,1.519l-2.277,12.063a1.762,1.762,0,0,0,.426,1.505,2,2,0,0,0,1.5.659Z" transform="translate(-458.128 -338.047)"></path><path class="atc-a" d="M487.748,333.729a.447.447,0,0,1-.46-.433,9.676,9.676,0,0,0-.346-2.6,7.408,7.408,0,0,0-.93-2.094,4.589,4.589,0,0,0-1.327-1.362,2.709,2.709,0,0,0-3.055,0A4.586,4.586,0,0,0,480.3,328.6a7.4,7.4,0,0,0-.929,2.094,9.677,9.677,0,0,0-.346,2.6.46.46,0,0,1-.919,0,9.439,9.439,0,0,1,1.413-5.15,5.466,5.466,0,0,1,1.59-1.621,3.673,3.673,0,0,1,4.09,0,5.468,5.468,0,0,1,1.59,1.621,9.439,9.439,0,0,1,1.414,5.15A.447.447,0,0,1,487.748,333.729Zm-4.589-7.372a3.252,3.252,0,0,1,1.774.543,5.007,5.007,0,0,1,1.453,1.485,7.8,7.8,0,0,1,.981,2.206,10.063,10.063,0,0,1,.36,2.7.022.022,0,0,0,.043,0,9.041,9.041,0,0,0-1.348-4.932,5.049,5.049,0,0,0-1.465-1.5,3.213,3.213,0,0,0-3.6,0,5.048,5.048,0,0,0-1.465,1.5,9.042,9.042,0,0,0-1.347,4.932.022.022,0,0,0,.043,0,10.068,10.068,0,0,1,.36-2.7,7.807,7.807,0,0,1,.981-2.206,5.008,5.008,0,0,1,1.453-1.485A3.252,3.252,0,0,1,483.159,326.357Z" transform="translate(-473.303 -325.904)"></path></g><circle cx="6" cy="6" r="6" transform="translate(30.147)"></circle><path class="atc-b" d="M.228-5.889v2.8h-2.77v.912H.228v2.8H1.19v-2.8H3.944v-.912H1.19v-2.8Z" transform="translate(35.443 8.684)"></path></g></svg> ${atcText} </span>`;
          } else {
            productHtml += '<span class="sold-out-inactive">Sold out</span>';
          }
          
          if (!product.available)
            productHtml += '<span class="sold-out-message hidden">Sold out</span>';
          else
            productHtml += '<div class="loading-overlay__spinner hidden"> <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"> <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>'    
          productHtml += '</button>'
          productHtml += '</form>';
          productHtml += '</product-form>'; 
        }
        
        productHtml += '</div>';
        productHtml += '</div>';
        productHtml += '</div>';
        
        return productHtml;
      }
    }
  }

  
  return Collection;
})();
new marmeto.Collection('marmeto-collection-template');

window.addEventListener('DOMContentLoaded', () => {
  let filterItems = document.querySelectorAll('.tag-filter-tab-container .filter-item');

  filterItems.forEach((item) => {
    item.addEventListener('click', function(event) {
      let currentDataTag = this.getAttribute('data-tag');
      document.querySelector('.tag-filter-content li.or.filter-selected')?.click();
      
      let allFilterItems = document.querySelectorAll('.tag-filter-content .filter-item');
      allFilterItems.forEach((filterItem) => {
          filterItem.classList.remove('filter-selected');
          filterItem.classList.remove('tab-filter-selected');
      });
      
      this.classList.toggle('tab-filter-selected');
      
      let dataTag =  document.querySelector(`.tag-filter-content li.or[data-tag="${currentDataTag}"]`);
      if(dataTag != null){
        dataTag.click();
      }
      document.querySelector(`.tag-filter-content li[data-tag="${currentDataTag}"]`).classList.add('filter-selected');
    });
  });

  let orElements = document.querySelectorAll('.tag-filter-content li.or');
  orElements.forEach((orElement) => {
    if (orElement.classList.contains('filter-selected')) {
      let dataTag = orElement.getAttribute('data-tag');
      document.querySelector(`[data-tag=${dataTag}]`).classList.add('filter-selected');
    }
  });

  if (document.querySelectorAll('.tag-filter-content li.or.filter-selected').length) {
    document.querySelector('[data-tag=all]')?.classList.remove('tab-filter-selected');
  } else {
    document.querySelector('[data-tag=all]')?.classList.add('tab-filter-selected');
  }
});


// highlight filter

// Extract the query parameter named "q" from the current URL
const urlString = window.location.href;
const url = new URL(urlString);
const queryParamValue = url.searchParams.get("q");

// Clean the query parameter value by removing hyphens
let cleanedQueryParamValue = null
if (queryParamValue != null) {
  cleanedQueryParamValue = queryParamValue.replace(/-/g, '');
}

// Select all <li> elements with the class "filter-item"
var liElements = document.querySelectorAll('li.filter-item');

// Loop through the <li> elements and extract the data-tag values
var matchingElement = null;

liElements.forEach(function(li) {
  var dataTagValue = li.getAttribute('data-tag');

  // Remove hyphens and underscores from the data-tag value using replace
  var modifiedValue = dataTagValue.replace(/[-_]/g, '');

  // Check if the cleaned query parameter value matches the modified data-tag value
  if (cleanedQueryParamValue === modifiedValue) {
    matchingElement = li;
    return; // Exit the loop when a match is found
  }
});

// Add the class 'tab-filter-selected' to the matching <li> element
if (matchingElement) {
  matchingElement.classList.add('tab-filter-selected');
}
